import { MouseEventHandler, ReactNode } from "react"
import { Balancer } from "react-wrap-balancer"
import cn from "classnames"

import { Collapsible } from "components"
import style from "modules/PsyCommon/components/TherapyRequestLookups/style.module.scss"
import { Img, TextWithIcon, Button, Tag } from "ui-kit/components-branded/index"
import { SurveyResultsStorage } from "modules/NewClientSurvey/common/utils/SurveyResultsStorage"

function ToggleButton({
    collapsed,
    onClick,
}: {
    collapsed: boolean
    onClick: MouseEventHandler<HTMLButtonElement>
}) {
    return (
        <Button hasSmallGaps onClick={onClick} className="is-align-self-center">
            {collapsed ? "Показать все" : "Свернуть"}
        </Button>
    )
}

interface Props {
    headline: ReactNode
    lookups: string[]
    className?: string
}

export function TherapyRequestLookups({ headline, lookups, className }: Props) {
    return (
        <div className={cn(style.wrapper, className)}>
            <TextWithIcon
                isAccent
                position="left"
                icon={<Img src="speech_balloon.png" width={24} />}
            >
                {headline}
            </TextWithIcon>
            <Collapsible
                collapsible={lookups.length > 5}
                renderList={(collapsed) => (
                    <>
                        {(collapsed ? lookups.slice(0, 5) : lookups).map((q, i) => (
                            <Tag key={i} className="is-wrap-mobile">
                                <Balancer>{q}</Balancer>
                            </Tag>
                        ))}
                    </>
                )}
                as={ToggleButton}
                className={cn("is-flex flex-wrap", style.tags, "mgt-4")}
            />
        </div>
    )
}

TherapyRequestLookups.isCanBeShown = (hashId: string) => {
    const storage = SurveyResultsStorage.extraData
    return (
        storage &&
        storage?.lookups?.length > 0 &&
        storage.profiles.map((profile) => profile.hash_id).includes(hashId)
    )
}
